import * as React from 'react';
import { Modal, Row, Input } from 'antd';
import Form, { FormItem } from '../../../components/Form';
import { IUpdateOrderItem } from 'data-layer/src/services/OrderItems/interfaces/IUpdateOrderItem';

interface IUpdateOrderItemEditorProps {
  item: GQL.IOrderItem;
  order: GQL.IOrder;
  onUpdate: (data: IUpdateOrderItem) => void;
  onCancel: () => void;
}

interface IUpdateOrderItemEditorState {
  data: {
    recommendedPrice: number | null;
    price: number;
    quantity: number;
  }
}

export default class UpdateOrderItemEditor extends React.Component<IUpdateOrderItemEditorProps, IUpdateOrderItemEditorState> {

  private form;

  constructor(props: IUpdateOrderItemEditorProps) {
    super(props);

    this.state = {
      data: {
        recommendedPrice: props.item.recommendedPrice,
        price: props.item.price,
        quantity: props.item.quantity
      }
    };

    this.form = React.createRef;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    const { item, order } = this.props;

    return (
      <Modal
        title={`${!item ? 'New' : 'Update'} order item`}
        visible={true}
        maskClosable={false}
        cancelText={'Cancel'}
        okText={'Update'}
        onOk={this.onSubmit}
        onCancel={() => this.props.onCancel()}
      >
        <Row>
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={() => this.props.onCancel()}
          >
            <FormItem label={'Recommended price'}>
              <Input
                name={'recommendedPrice'}
                placeholder="Recommended price"
                addonAfter={order.currency ? order.currency.value : undefined}
                value={this.state.data.recommendedPrice || undefined}
                type={'number'}
                step={'0.01'}
                onChange={(e: any) => this.onChange(e, parseFloat(e.target.value))}
              />
            </FormItem>
            <FormItem label={'Price with VAT'} required={true}>
              <Input
                name={'price'}
                placeholder="Price"
                value={this.state.data.price || undefined}
                addonAfter={order.currency ? order.currency.value : undefined}
                required={true}
                type={'number'}
                step={'0.01'}
                onChange={(e: any) => this.onChange(e, parseFloat(e.target.value))}
              />
            </FormItem>
            <FormItem label={'Quantity'} required={true}>
              <Input
                name={'quantity'}
                placeholder="Quantity"
                value={this.state.data.quantity}
                required={true}
                type={'number'}
                onChange={(e: any) => {
                  if (!isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0) {
                    this.onChange(e, parseInt(e.target.value));
                  }
                }}
              />
            </FormItem>
          </Form>
        </Row>
      </Modal>
    );
  }

  private onChange(e: any, val: any = null) {
    const value = val === null ? e.target.value : val;

    this.setState({
      data: {...this.state.data, [e.target.name]: value},
    });
  }

  private async onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onUpdate(this.state.data as IUpdateOrderItem);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderItems/OrderItemsEditors/UpdateOrderItemEditor2.tsx